<h1 class="tw-m-0 tw-text-center tw-font-rubik tw-text-xl tw-font-medium tw-leading-none tw-text-black">
  {{ titleKey() | translate }}
</h1>

<p
  class="tw-mb-0 tw-mt-[33px] tw-max-w-[461px] tw-text-center tw-font-rubik tw-text-base tw-font-normal tw-leading-snug tw-text-black">
  {{ explainKey() | translate }}
</p>
